import classNames from 'classnames';
import { Button } from 'components/blocks/Button';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import {
  useCallback, useRef, useState,
} from 'react';
import { useOnLayoutChangeEffect } from 'util/useOnLayoutChange';

import styles from './styles.module.scss';

export interface IProps {
  text: string,
  buttonClass?: string,
  textClass?: string,
  length?: number,
  inline?: boolean,
}

export const ReadMore = ({
  text: rawText, buttonClass, textClass, length = 200, inline = false,
}: IProps) => {
  const text = rawText;
  const [isExpanded, setExpanded] = useState<boolean>(true);
  const shouldCut = text.length > length;
  const { t } = useOTSTranslation('common');

  const toggleReadMore = useCallback(() => {
    setExpanded((v) => !v);
  }, [setExpanded]);

  return (
    <>
      <div className={classNames(textClass, styles.boxReadMore)} aria-label={text}>
        {(isExpanded && shouldCut) ? `${text.slice(0, length)}...` : text}
        {shouldCut && (
          <Button
            className={classNames(inline ? styles.inline : '', buttonClass)}
            onClick={toggleReadMore}
          >
            {isExpanded ? t('resort.overview.readMore') : t('resort.overview.showLess')}
          </Button>
        )}
      </div>
    </>
  );
};

export const ReadMoreNoCut = ({
  text: rawText, buttonClass, textClass, inline = false,
}: IProps) => {
  const text = rawText;
  const [isExpanded, setExpanded] = useState<boolean>(false);
  const [shouldShowBtn, setShouldShowBtn] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useOTSTranslation('common');

  const toggleReadMore = useCallback(() => {
    setExpanded((v) => !v);
  }, [setExpanded]);

  useOnLayoutChangeEffect(() => {
    if (!isExpanded && ref.current) {
      setShouldShowBtn(ref.current?.clientHeight < ref.current?.scrollHeight);
    }
  }, [isExpanded]);

  return (
    <>
      <div className={classNames(textClass, styles.boxReadMore)} aria-label={text}>
        <div ref={ref} className={classNames({ [styles.collapsed]: !isExpanded }, shouldShowBtn && !isExpanded && styles.fadeout)}>{text}</div>
        {shouldShowBtn && (
          <Button
            className={classNames(styles.separate, inline ? styles.inline : '', buttonClass)}
            onClick={toggleReadMore}
          >
            {isExpanded ? t('resort.overview.showLess') : t('resort.overview.readMore')}
          </Button>
        )}
      </div>
    </>
  );
};
